// dot_show: false,
// number_show: false,

export const scoreConfig_AllergyandEczema_oms = [
    {
        titel: `Overweight`,
        match_key: 'Overweight',
        Xdotpos: 177,
        Ydotpos: 275,
        Xnumberpos: 580,
        Ynumberpos: 250,
        formula: 'static_asthma_score',
        max_dot: 10,
        // page: 18,
        dot_show: false,
        number_show: false,
        value_use: [
            'Akkermansia muciniphila',
            // 'Bacteroidetes phylum',
            'Faecalibacterium prausnitzii',
            'Bifidobacterium bifidum',
            // 'Bifidobacterium breve',
            // 'Bifidobacterium longum',
            // 'Lactobacillus acidophilus',
            'Lactobacillus gasseri',
            // 'Lactobacillus plantarum'
          ],
        table_socre: [
            {min: 0, max: 3, color_dot: '#fae01f', label: 'Low'},
            {min: 4, max: 6, color_dot: '#fa891f',label: 'Moderate'},
            {min: 7, max: 10, color_dot: '#fa1f1f', label: 'High'}
        ]
    },
    {
        titel: ['Metabolic', 'syndrome'],
        match_key: 'Metabolic syndrome',
        Xdotpos: 177,
        Ydotpos: 385,
        Xnumberpos: 580,
        Ynumberpos: 360,
        formula: 'static_asthma_score',
        max_dot: 10,
        // page: 18,
        dot_show: false,
        number_show: false,        
        value_use: [
            'Akkermansia muciniphila',
            'Faecalibacterium prausnitzii',
            'Bifidobacterium lactis',
            'Lactobacillus acidophilus',
            'Lactobacillus paracasei'
          ],
        table_socre: [
            {min: 0, max: 3, color_dot: '#fae01f', label: 'Low'},
            {min: 4, max: 6, color_dot: '#fa891f',label: 'Moderate'},
            {min: 7, max: 10, color_dot: '#fa1f1f', label: 'High'}
        ]
    },
    {
        titel: ['Visceral fat', 'accumulation'],
        match_key: 'Visceral',
        Xdotpos: 177,
        Ydotpos: 385,
        Xnumberpos: 580,
        Ynumberpos: 360,
        formula: 'static_asthma_score',
        max_dot: 10,
        // page: 18,
        dot_show: false,
        number_show: false,        
        value_use: [
            'Akkermansia muciniphila',
            'Bacteroidetes phylum',
            'Faecalibacterium prausnitzii',
            'Bifidobacterium bifidum',
            'Lactobacillus gasseri',
            'Lactobacillus paracasei',
            'Lactobacillus rhamnosus',
            'Firmicutes phylum'
          ],
        table_socre: [
            {min: 0, max: 2, color_dot: '#fae01f', label: 'Low'},
            {min: 3, max: 4, color_dot: '#fa891f',label: 'Moderate'},
            {min: 5, max: 100, color_dot: '#fa1f1f', label: 'High'}
        ]
    },
    {
        titel: 'Insulin resistance',
        match_key: 'Insulin',
        Xdotpos: 177,
        Ydotpos: 385,
        Xnumberpos: 580,
        Ynumberpos: 360,
        formula: 'static_asthma_score',
        max_dot: 10,
        // page: 18,
        dot_show: false,
        number_show: false,        
        value_use: [
            'Akkermansia muciniphila',
            'Bacteroidetes phylum',
            'Faecalibacterium prausnitzii',
            'Bifidobacterium bifidum',
            'Lactobacillus gasseri',
            'Lactobacillus paracasei',
            'Lactobacillus rhamnosus',
            'Lactobacillus reuteri'
          ],
        table_socre: [
            {min: 0, max: 3, color_dot: '#fae01f', label: 'Low'},
            {min: 4, max: 6, color_dot: '#fa891f',label: 'Moderate'},
            {min: 7, max: 100, color_dot: '#fa1f1f', label: 'High'}
        ]
    },
    {
        // Type 2 diabetes page 18
        titel: `['Type 2', 'diabetes']`,
        match_key: 'Type 2 diabetes',
        Xdotpos: 177,
        Ydotpos: 496,
        Xnumberpos: 580,
        Ynumberpos: 470,
        formula: 'static_asthma_score',
        max_dot: 10,
        // page: 18,
        dot_show: false,
        number_show: false,           
        value_use: [
            'Akkermansia muciniphila',
            'Bacteroides fragilis',
            'Faecalibacterium prausnitzii',
            'Bacillus genus',
            'Candida albicans',
            'Bifidobacterium longum',
            'Lactobacillus gasseri',
            'Lactobacillus plantarum',
            'Lactobacillus reuteri'
          ],
        table_socre: [
            {min: 0, max: 3, color_dot: '#fae01f', label: 'Low'},
            {min: 4, max: 6, color_dot: '#fa891f',label: 'Moderate'},
            {min: 7, max: 100, color_dot: '#fa1f1f', label: 'High'}
        ]
    },
    {
        titel: 'Fatty liver',
        match_key: 'Fatty liver',
        Xdotpos: 177,
        Ydotpos: 385,
        Xnumberpos: 580,
        Ynumberpos: 360,
        formula: 'static_asthma_score',
        max_dot: 10,
        // page: 18,
        dot_show: false,
        number_show: false,        
        value_use: [
            'Akkermansia muciniphila',
            'Bacteroidetes phylum',
            'Faecalibacterium prausnitzii',
            'Ruminococcus obeum',
            'Bifidobacterium bifidum',
            'Lactobacillus paracasei',
            'Lactobacillus rhamnosus',
            'Lactobacillus reuteri',
            'Firmicutes phylum',
            'Blautia genus'

          ],
        table_socre: [
            {min: 0, max: 1, color_dot: '#fae01f', label: 'Low'},
            {min: 2, max: 3, color_dot: '#fa891f',label: 'Moderate'},
            {min: 4, max: 100, color_dot: '#fa1f1f', label: 'High'}
        ]
    },
    {
        // Excessive lipopolysaccharide page 18
        titel: `['Excessive', 'lipopolysaccharide']`,
        match_key: 'Excessive lipopolysaccharide',
        Xdotpos: 177,
        Ydotpos: 610,
        Xnumberpos: 580,
        Ynumberpos: 582,
        formula: 'static_asthma_score',
        max_dot: 10,
        // page: 18,
        dot_show: false,
        number_show: false,           
        value_use: [
            'Akkermansia muciniphila',
            'Bifidobacterium bifidum',
            'Lactobacillus acidophilus',
            'Lactobacillus paracasei',
            'Lactobacillus plantarum'
          ],
        table_socre: [
            {min: 0, max: 3, color_dot: '#fae01f', label: 'Low'},
            {min: 4, max: 6, color_dot: '#fa891f',label: 'Moderate'},
            {min: 7, max: 10, color_dot: '#fa1f1f', label: 'High'}
        ]
    },
]

// Export bacteria type configuration for OMS format
export const typeofbacteria_oms = {
  core_bacteria: [
    'Akkermansia muciniphila',
    'Bacteroidetes phylum',
    'Faecalibacterium prausnitzii'
  ],
  harmful_bacteria: [
    'Blautia genus',
    'Firmicutes phylum',
    'Ruminococcus obeum'
  ],
  beneficial_bacteria: [
    'Bifidobacterium bifidum',
    'Lactobacillus gasseri',
    'Lactobacillus paracasei',
    'Lactobacillus rhamnosus',
    'Lactobacillus reuteri'
  ]
};
